import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services/store-selectors.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";

@Component({
    selector: 'app-scene-block-radio',
    templateUrl: './block-radio.component.html',
    styleUrls: ['./block-radio.component.scss']
})
export class BlockRadioComponent extends BlockBaseComponent {

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.label', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "label",
                storePath: 'Data[0].Radio[0].$.label'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.value', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "value",
                storePath: 'Data[0].Radio[0].$.value'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.fieldName', {}, this.translocoService.getActiveLang()),
                name: "fieldName",
                inputType: "text",
                storePath: 'Data[0].Radio[0].$.fieldName'
            }
        ];
    }
}

